export default "__VITE_ASSET__t4bleQjW__"